import api from '@/api'

const {$practica, $core} = api;
const $st = api.$student

export const {$presentationLetter, $requirements, $companyPractice, $saveCompanyPractice, $practiceAgreement} = $practica;
export const { $student, $examenes } = $st;
export const { $citiesWithState } = $core;

